import React from 'react';
import { formatMoney } from './quickPriceListModel';

export const costNumber = (value) => value !== null && value !== undefined && String(value).trim() !== '' && Number.isFinite(Number(value)) ? Number(value) : null;
export const referenceMoney = (value) => costNumber(value) === null ? 'Sin dato' : formatMoney(Number(value));
export const saleCostScope = (costs = {}, formatLabel = '') => {
  const unit = costs.referenceCostBreakdown?.priceMetricUnit;
  return `Por unidad de venta${formatLabel ? ` · ${formatLabel}` : ''}${unit ? ` (${unit})` : ''}`;
};

export const calculatedCostForBasis = (costs, basis) => {
  const sourceBasis = costs.pricingBasis || costs.manualBaseCostBasis || 'unit';
  if (basis === sourceBasis && costNumber(costs.calculatedCost) !== null) return costs.calculatedCost;
  const breakdown = costs.referenceCostBreakdown || {};
  return basis === 'kg' ? breakdown.referenceCostPerKg ?? breakdown.costPerKg : breakdown.referenceCost;
};

export const costAvailabilityMessage = (input = {}) => {
  const costs = input || {};
  const status = costs.calculatedCost === null
    ? costs.referenceCostBreakdown?.conversionStatus || costs.conversionStatus
    : costs.conversionStatus;
  if (status === 'missing_unit_weight' || costs.conversionStatus === 'missing_unit_weight' || costs.pricingBasisStatus === 'pending_unit_weight') return 'Falta el peso de la unidad de venta para convertir el costo por kg al formato.';
  if (status === 'missing_total_kg') return 'Faltan los kilos totales de la compra para calcular el costo por kg.';
  if (status === 'missing_stock') return 'Todavía no hay una compra utilizable para este formato.';
  if (status === 'missing_conversion' || status === 'missing_unit_conversion') return 'Falta la equivalencia entre la unidad de compra y la unidad de venta.';
  if (status === 'missing_price_unit') return 'Falta definir la unidad de venta del formato.';
  if (status === 'unit_not_in_import') return 'La unidad de venta no tiene una compra en esta lista de importación de reventa.';
  if (status === 'missing_stock_unit') return 'Falta definir la unidad de compra en la importación.';
  return 'Revisa el peso y la equivalencia entre la unidad de compra y la unidad de venta.';
};

export function CostValues({ values }) {
  return <dl className={`grid grid-cols-2 gap-3 ${values.length === 4 ? 'lg:grid-cols-4' : 'sm:grid-cols-3'}`}>
    {values.map(({ label, value, scope }) => <div key={label} className="min-w-0 rounded-lg bg-white/80 p-3">
      <dt className="text-xs text-slate-600">{label}</dt>
      <dd className="mt-1 font-semibold text-slate-950">{referenceMoney(value)}</dd>
      <dd className="mt-1 text-xs text-slate-500">{scope}</dd>
    </div>)}
  </dl>;
}

export default function StockCostReferenceSummary({ costs = {}, formatLabel = '', title = 'Actual, antes de editar' }) {
  const components = costs.costComponents || {};
  const scope = saleCostScope(costs, formatLabel);
  const values = [
    { label: 'Costo efectivo', value: costs.referenceCost, scope },
    { label: 'Costo base de compra', value: components.base?.available ? components.base.perSaleUnit : null, scope },
    { label: 'Costo operacional', value: components.operational?.available ? components.operational.perSaleUnit : null, scope },
  ];
  if (costs.pricingBasis === 'kg' || costs.manualBaseCostBasis === 'kg') {
    values.push(
      { label: 'Costo efectivo por kg', value: costs.referenceCostPerKg, scope: 'Por kg' },
      { label: 'Costo base por kg', value: costs.baseCostPerKg ?? (components.base?.available ? components.base.perKg : null), scope: 'Por kg' },
      { label: 'Costo operacional por kg', value: costs.allocatedExpenseCostPerKg ?? (components.operational?.available ? components.operational.perKg : null), scope: 'Por kg' },
    );
  }
  return <section className="rounded-xl border border-slate-200 bg-slate-50 p-4" aria-label={title}>
    <h3 className="mb-3 text-sm font-bold text-slate-950">{title}</h3>
    <CostValues values={values} />
  </section>;
}
